import { Navigate } from "react-router-dom";
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import { LogoutModal } from './logout.js';

function Dashboard() {
  const isLoggedIn = sessionStorage.getItem("userToken");
  if(isLoggedIn){
    return(
      <>
      <div id="wrapper">
          <SideNav />
          <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                  <TopBar />
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-xs-12 col-md-12">
                        <div className="card shadow mb-4">
                          <div className="card-body">
                            <h2 className="text-center">Welcome to Whispering Oaks Property Owner Dashboard.</h2>
                            <p className="text-center">Please choose a menu option from the left navigation</p>                          
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>                    
              </div>
              <Footer />
          </div>
      </div>
      <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
      </a>
      <LogoutModal />
      </>
    )
  }else{
    return (
      <Navigate to="/login" />
    );
  }
}

export { Dashboard };
